module.exports = __webpack_public_path__ + "static/media/download.f4797544.svg";